import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
          // component: () => import("@/views/default/_home.vue")
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        },
        {
          path: "/attachment",
          component: () => import("@/views/default/_attachment.vue"),
          props: true
        },
        {
          path: "/firstTime",
          component: () => import("@/views/default/_firstTime.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/security",
          component: () => import("@/views/default/_security.vue"),
          meta: { requiredLoggedIn: true}
        },
        {
          path: "/resetPassword",
          component: () => import("@/views/default/_resetPassword.vue"),
          meta: { requiredLoggedIn: true}
        }
      ]
    },
    // {
    //   path: "/system",
    //   component: () => import("@/views/system/index.vue"),
    //   children: [
    //     {
    //       path: "/system/setting",
    //       component: () => import("@/views/system/_setting.vue"),
    //       meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.setting], subAccPage: [config.accessRoles.system] }
    //     },
    //     {
    //       path: "/system/dashboard",
    //       component: () => import("@/views/system/_dashboard.vue"),
    //       meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dashboard], subAccPage: [config.accessRoles.system] }
    //     }
    //   ],
    //   meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.setting, config.accessRoles.dashboard], subAccPage: [config.accessRoles.system] }
    // },
    {
      path: "/ticket",
      component: () => import("@/views/ticket/index.vue"),
      children: [
        {
          path: "/ticket",
          component: () => import("@/views/ticket/_ticket.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket], subAccPage: [config.subAccessRoles.ticket] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket], subAccPage: [config.subAccessRoles.ticket] }
    },
    {
      path: "/bank",
      component: () => import("@/views/bank/index.vue"),
      children: [
        {
          path: "/bank/bankOperator",
          component: () => import("@/views/bank/_bankOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankoperator], subAccPage: [config.subAccessRoles.bank] }
        },
        {
          path: "/bank/bankMember",
          component: () => import("@/views/bank/_bankMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankmember], subAccPage: [config.subAccessRoles.bank] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankoperator, config.accessRoles.bankmember], subAccPage: [config.subAccessRoles.bank] }
    },
    {
      path: "/promotion",
      component: () => import("@/views/promotion/index.vue"),
      children: [
        {
          path: "/promotion/promoPackage",
          component: () => import("@/views/promotion/_promoPackage.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promopackage], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/promoAccount",
          component: () => import("@/views/promotion/_promoAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promoaccount], subAccPage: [config.subAccessRoles.promotion] }
        },
        {
          path: "/promotion/promoMember",
          component: () => import("@/views/promotion/_promoMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promomember], subAccPage: [config.subAccessRoles.promotion] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promopackage, config.accessRoles.promoaccount, config.accessRoles.promomember], subAccPage: [config.subAccessRoles.promotion] }
    },
    {
      path: "/ibank",
      component: () => import("@/views/ibank/index.vue"),
      children: [
        {
          path: "/ibank/ibankAccount",
          component: () => import("@/views/ibank/_ibankAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibankaccount], subAccPage: [config.subAccessRoles.bank] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ibankaccount], subAccPage: [config.subAccessRoles.bank] }
    },
    {
      path: "/account",
      component: () => import("@/views/account/index.vue"),
      children: [
        {
          path: "/account/operator",
          component: () => import("@/views/account/_operator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.operator], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/member",
          component: () => import("@/views/account/_member.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.member], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/subaccount",
          component: () => import("@/views/account/_subAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.subaccount], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/socialaccount",
          component: () => import("@/views/account/_socialAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.socialaccount], subAccPage: [config.subAccessRoles.account] }
        },
        {
          path: "/account/membernickname",
          component: () => import("@/views/account/_memberNickname.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.membernickname], subAccPage: [config.subAccessRoles.account] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.member, config.accessRoles.operator, config.accessRoles.subaccount, config.accessRoles.socialaccount, config.accessRoles.membernickname], subAccPage: [config.subAccessRoles.account]}
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true }
        },
        {
          path: "/system/dashboard",
          component: () => import("@/views/system/_dashboard.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dashboard], subAccPage: [config.subAccessRoles.system] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [], subAccPage: [config.subAccessRoles.system]}
    },
    {
      path: "/log",
      component: () => import("@/views/log/index.vue"),
      children: [
        {
          path: "/log/adjustMemberLog",
          component: () => import("@/views/log/_adjustMemberLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmemberlog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/issueBonusLog",
          component: () => import("@/views/log/_issueBonusLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.issuebonuslog], subAccPage: [config.subAccessRoles.log] }
        },
        {
          path: "/log/loginMemberLog",
          component: () => import("@/views/log/_loginMemberLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.loginmemberlog], subAccPage: [config.subAccessRoles.log] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.adjustmemberlog, config.accessRoles.issuebonuslog, config.accessRoles.loginmemberlog], subAccPage: [config.subAccessRoles.log] }
    },
    {
      path: "/report",
      component: () => import("@/views/report/index.vue"),
      children: [
        {
          path: "/report",
          redirect: "/report/dailyStatement"
        },
        {
          path: "/report/dailyStatement",
          component: () => import("@/views/report/_dailyStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailystatement], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/dailyWinLose",
          component: () => import("@/views/report/_dailyWinLose.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/gameResultSlots",
          component: () => import("@/views/report/_gameResultSlots.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultslots], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/bankStatement",
          component: () => import("@/views/report/_bankStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bankstatement], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/transferList",
          component: () => import("@/views/report/_transferList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.transferlist], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/bonusAndAdjustment",
          component: () => import("@/views/report/_bonusAndAdjustment.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bonusandadjustment], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/promotionReport",
          component: () => import("@/views/report/_promotionReport.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.promotionreport], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/registeredMember",
          component: () => import("@/views/report/_registeredMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.registeredmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/depositedMember",
          component: () => import("@/views/report/_depositedMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.depositedmember], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/firstDeposit",
          component: () => import("@/views/report/_firstDeposit.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.firstdeposit], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/report/referredMember",
          component: () => import("@/views/report/_referredMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.referredmember], subAccPage: [config.subAccessRoles.report] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bonusandadjustment, config.accessRoles.dailystatement, config.accessRoles.dailywinlose,
                                                      config.accessRoles.gameresultslots, config.accessRoles.bankstatement, config.accessRoles.transferlist,
                                                      config.accessRoles.transferlist, config.accessRoles.promotionreport, config.accessRoles.registeredmember,
                                                      config.accessRoles.depositedmember, config.accessRoles.firstdeposit, config.accessRoles.referredmember], subAccPage: [config.subAccessRoles.report] }
    },
    {
      path: "/reportNest",
      component: () => import("@/views/reportNest/index.vue"),
      children: [
        {
          path: "/reportNest",
          redirect: "/reportNest/dailyStatement"
        },
        {
          path: "/reportNest/dailyStatementNest",
          component: () => import("@/views/reportNest/_dailyStatementNest.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailystatement], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/reportNest/dailyWinLoseNest",
          component: () => import("@/views/reportNest/_dailyWinLoseNest.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.dailywinlose], subAccPage: [config.subAccessRoles.report] }
        },
        {
          path: "/reportNest/downlineOperator",
          component: () => import("@/views/reportNest/_downlineOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.gameresultslots], subAccPage: [config.subAccessRoles.report] }
        },
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bonusandadjustment, config.accessRoles.dailystatement, config.accessRoles.dailywinlose], subAccPage: [config.subAccessRoles.report] }
    }
  ]
});

export default router;
